module.exports = __webpack_public_path__ + "static/media/icons8-search.938e6675.svg";